import css from 'styled-jsx/css';

const styles = css.global`#leilao-de-veiculos-conheca {
  background: #FFF;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 {
  padding-top: 32px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .ctn-home-24 {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: 14px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .ctn-home-24 img {
  width: 300px;
  padding: 17.162px 9.671px 38.065px 9.672px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .por-que-textos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .por-que-titulo {
  margin: 0;
  color: #444;
  font-family: "SantanderHeadline";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .por-que-subtitulo {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p2 {
  padding: 26px 0 40px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p2 .custom-carousel .embla__container {
  max-width: 940px;
  margin: auto;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p2 .slide {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 199px;
  height: 192px;
  padding: 50px 3.621px 50px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #CCC;
  background: #C00;
  margin-right: 16px;
  flex: 0 0 199px;
}

#leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p2 .slide .slide-texo {
  color: #FFF;
  text-align: center;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#leilao-de-veiculos-conheca .home-pagination {
  margin-top: 48px;
  max-width: 256px;
}

#leilao-de-veiculos-conheca .home-pagination .embla__prev.enable-mobile-arrows, 
#leilao-de-veiculos-conheca .home-pagination .embla__next.enable-mobile-arrows {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}

#leilao-de-veiculos-conheca .img-separador-leilao {
  height: 320px;
  display: block;
}


#leilao-de-veiculos-conheca .img-separador-leilao img {
  width: 100%;
  height: 320px;
  object-fit: cover;
}

@media (min-width: 992px) {
  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 {
    padding: 40px 0 64px;
  }
  
  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .ctn-home-24 {
    display: flex;
    flex-direction: row-reverse;
    gap: 32px;
    justify-content: space-between;
  }
  
  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .ctn-home-24 img {
    width: 400px;
    padding: 22.883px 12.895px 50.753px 12.895px;
    margin-right: 86.5px;
  }

  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .por-que-textos {
    gap: 24px;
  }

  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .por-que-titulo {
    font-size: 56px;
    line-height: 120%;
    max-width: 440px;
  }
  
  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p1 .por-que-subtitulo {
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-weight: 400;
    line-height: 36px;
    max-width: 600px;
}

  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p2 {
    padding: 24px 0 56px;
  }

  #leilao-de-veiculos-conheca .leilao-de-veiculos-conheca-p2 .slide {
    margin-right: 48px;
  }

  #leilao-de-veiculos-conheca .home-pagination {
    display: none;
  }
}
`;

export default styles;